import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M5.625 15.375L12 8.625L18.375 15.375' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.59192 15.8203C4.76972 16.2328 5.17585 16.5 5.62503 16.5H18.375C18.8242 16.5 19.2303 16.2328 19.4081 15.8203C19.5859 15.4078 19.5013 14.9291 19.1929 14.6025L12.8179 7.85255C12.6054 7.62752 12.3095 7.5 12 7.5C11.6905 7.5 11.3947 7.62752 11.1821 7.85255L4.80714 14.6025C4.49872 14.9291 4.41411 15.4078 4.59192 15.8203ZM8.23495 14.25L12 10.2635L15.7651 14.25H8.23495Z'
            />
        </SvgIcon>
    );
});
